import { render, staticRenderFns } from "./RugbyStats.vue?vue&type=template&id=60b51e2a&scoped=true&"
import script from "./RugbyStats.vue?vue&type=script&lang=js&"
export * from "./RugbyStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b51e2a",
  null
  
)

export default component.exports